import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Button as Btn } from 'components';
import { Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './AdminLog.css';
const cx = classNames.bind(styles);

class AdminLogFilter extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { handleInitFilter, filterClose, cancleCheck, executeFilter, paramData, filters, tempFilter, popupOpen, handlePopup } = this.props;

    // 구분 필터
    const logType = [
      { 1: defineMessages(formatMessage({ id: 'AdminLog_6', defaultMessage: '사용자 로그인' })) },
      { 2: defineMessages(formatMessage({ id: 'AdminLog_26', defaultMessage: '관리자 로그인' })) },
      { 4: defineMessages(formatMessage({ id: 'AdminLog_7', defaultMessage: '시스템' })) },
      { 8: defineMessages(formatMessage({ id: 'AdminLog_8', defaultMessage: '일반' })) }
    ];

    const logTypeFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header content={defineMessages(formatMessage({ id: 'AdminLog_5', defaultMessage: '구분' }))} />
        {logType.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.logTypeFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['logType'] && Number(Object.keys(data)[0]) & tempFilter['logType']
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    const logTypeArray = paramData.getIn(['filter', 'logType']) ? paramData.getIn(['filter', 'logType']) : 0;

    const totalArrayLength = logTypeArray.length;

    let logTypeInfo = null;
    if (logTypeArray > 0) {
      logTypeInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'AdminLog_5', defaultMessage: '구분' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {logType.map((data, index) => {
              let templateStatus = '';
              if (1 & logTypeArray) {
                templateStatus = defineMessages(formatMessage({ id: 'AdminLog_6', defaultMessage: '사용자 로그인' }));
              } else if (2 & logTypeArray) {
                templateStatus = defineMessages(formatMessage({ id: 'AdminLog_26', defaultMessage: '관리자 로그인' }));
              } else if (4 & logTypeArray) {
                templateStatus = defineMessages(formatMessage({ id: 'AdminLog_7', defaultMessage: '시스템' }));
              } else if (8 & logTypeArray) {
                templateStatus = defineMessages(formatMessage({ id: 'AdminLog_8', defaultMessage: '일반' }));
              }

              return (
                <span key={index} className={cx('context-value')}>
                  {templateStatus}
                </span>
              );
            })}
          </span>
        </div>
      );
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />
        {logTypeInfo}
      </div>
    );

    return (
      <Tooltip
        classes={{
          tooltip: 'tooltip',
          tooltipOpen: totalArrayLength > 0 ? '' : 'close'
        }}
        title={tooltipInfo}
        placement="bottom">
        <div className={cx('target-dropdown-area', totalArrayLength > 0 ? 'target-dropdown-area-border' : '')}>
          <div className={cx('dropdown-arrow-area', 'table-filter-arrow')}>
            {totalArrayLength > 0 ? (
              <div className={cx('number-box')}>{totalArrayLength}</div>
            ) : (
              <Image className={cx('dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
            )}
          </div>
          <Popup
            className={cx('filter-popup')}
            trigger={
              <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_35', defaultMessage: '필터' }))}
              </div>
            }
            open={popupOpen}
            onOpen={() => handlePopup(true)}
            onClose={() => { filterClose(), handlePopup(false) }}
            on="click"
            flowing
            position="bottom center">
            <Grid centered divided columns={1}>
              <Grid.Column textAlign="left">{logTypeFilterOptions}</Grid.Column>
            </Grid>
            <Grid className={cx('bottom-options')}>
              <Grid.Column className={cx('multi-row')}>
                <div className={cx('all-check-off')} onClick={handleInitFilter}>
                  {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                </div>
                <div className={cx('inline-block')}>
                  <Btn className={cx('button-border', 'button')} onClick={() => { cancleCheck(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                  </Btn>
                  <Btn
                    className={cx('button-brand', 'button')}
                    // loading={editOnProgress}
                    // disabled={disableSave && (editInvalid || editOnProgress)}
                    onClick={() => { executeFilter(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                  </Btn>
                </div>
              </Grid.Column>
            </Grid>
          </Popup>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(AdminLogFilter);



// WEBPACK FOOTER //
// ./src/script/components/admin/AdminLogFilter.js